import mock from "../mock";
let data = {
  events: [
    {
      id: 1,
      title: "asdasdasdas dasd as d",
      start: new Date(2020, 5, 28, 14, 0, 0),
      end: new Date(2020, 5, 29, 14, 0, 0),
      label: "business",
      allDay: true,
      selectable: true,
    },
    {
      id: 2,
      title: "asdasdasdas dasd as d",
      start: new Date(2020, 4, 19, 14, 0, 0),
      end: new Date(2020, 4, 19, 15, 0, 0),
      label: "business",
      allDay: true,
      selectable: true,
    },
  ],
};

// GET : Calendar Events
mock.onGet("/api/apps/calendar/events").reply(() => {
  return [200, data.events];
});
